import React from "react";
import "../css/vehicle.css";
import { hasPermission } from "../utils/permissionHelper";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const GRNTransactions = () => {
  useAuthRedirect();

  const canEntry  = hasPermission("GRN", "entry");


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">GRN Menu
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Transaction</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/grnView">GRN</Link></td>
          </tr>

          {canEntry && (
            <>
          <tr>
            <td><Link to="/inventory/grnInspection">GRN Inspection</Link></td>
          </tr>
          <tr>
          <td><Link to="/inventory/grnConfirm">GRN Confirm</Link></td>
          </tr>
          </>
          )}
          <tr>
          {/* <td><Link to="/inventory/grnReject">GRN Rejection</Link></td> */}
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default GRNTransactions;
